import React from "react";

const Unauthorized = () => (
  <div className="h-screen">
    <p>Unauthorized</p>
  </div>
);

export default Unauthorized;
